<template>
	<div class="scroll-tag"
	    :name="name"
	    :title="title">
		<div class="scroll-tag-dot"
		    :class="{
                'is-active': active
            }"></div>
		<div class="scroll-tag-value single-line-clip">{{ title }}</div>
		<common-icon class="scroll-tag-close"
		    type="ios-close"
		    @click.native.stop="onClose"></common-icon>
	</div>
</template>
<script>
export default {
	name: "ScrollTag",

	props: {
		name: String,
		title: String,
		active: {
			type: Boolean,
			default: false,
		},
	},

	methods: {
		onClose() {
			this.$emit("close")
		}
	},
}
</script>
<style lang="less"
    scoped>
.scroll {
	&-tag {
		position: relative;
		display: inline-block;
		height: 32px;
		padding: 0 30px;
		margin: 2px 4px 2px 0;
		font-size: 12px;
		line-height: 32px;
		border: 1px solid @border-color-split;
		vertical-align: middle;
		cursor: pointer;

		&-dot {
			display: inline-block;
			width: 12px;
			height: 12px;
			position: absolute;
			left: 12px;
			top: 50%;
			margin-top: -5px;
			border-radius: 50%;
			background: @border-color-split;

			&.is-active {
				background: @primary-color;
			}
		}

		&-value {
			max-width: 150px;

			&:hover {
				opacity: 0.85;
			}
		}

		&-close {
			display: inline-block;
			width: 12px;
			height: 12px;
			position: absolute;
			right: 12px;
			top: 5px;
			font-size: 21px;
			color: #666;
			cursor: pointer;

			&:hover {
				opacity: 0.85;
			}
		}
	}
}
</style>